// extracted by mini-css-extract-plugin
export default {"menuBlock":"PG-z","title":"QG-z","nav":"RG-z","flexCell":"SG-z","facetLink":"TG-z"};